import React, { useState } from "react";
import { LineChart,Line,XAxis,YAxis,Tooltip,ReferenceLine,ResponsiveContainer } from "recharts";
const EC={binance:"#f59e0b",bybit:"#3b82f6",okx:"#a855f7"};
export default function FundingPanel({ data }) {
  const [sel,setSel] = useState("binance");
  if (!data?.exchanges) return <p style={{color:"#6b7280"}}>데이터 없음</p>;
  const {exchanges,avg_rate} = data;
  const hist = exchanges[sel]?.history||[];
  const cd = hist.slice(-24).map(h=>({ts:h.ts,rate:parseFloat((h.rate||0).toFixed(4))}));
  return (
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        {Object.entries(exchanges).map(([ex,d])=>{
          const rate=d?.current??0; const isPos=rate>=0; const hot=Math.abs(rate)>0.05;
          return (
            <button key={ex} onClick={()=>setSel(ex)} style={{flex:1,minWidth:80,padding:"8px 10px",
              borderRadius:8,cursor:"pointer",background:sel===ex?"#181c24":"#111318",
              border:sel===ex?`1.5px solid ${EC[ex]}`:"1px solid #1e2433",textAlign:"left"}}>
              <p style={{fontSize:11,fontWeight:700,textTransform:"capitalize",color:EC[ex],marginBottom:3}}>{ex}</p>
              <p style={{fontSize:15,fontWeight:700,
                color:hot?(isPos?"#ef4444":"#3b82f6"):(isPos?"#22c55e":"#ef4444")}}>
                {isPos?"+":""}{rate.toFixed(4)}%
              </p>
            </button>
          );
        })}
      </div>
      <p style={{fontSize:12,color:"#6b7280"}}>
        평균: <span style={{color:avg_rate>=0?"#22c55e":"#ef4444",fontWeight:700}}>
          {avg_rate>=0?"+":""}{(avg_rate||0).toFixed(4)}%
        </span>
      </p>
      {cd.length>1&&(
        <ResponsiveContainer width="100%" height={120}>
          <LineChart data={cd}>
            <XAxis dataKey="ts" hide/>
            <YAxis tick={{fill:"#4b5563",fontSize:10}} axisLine={false} tickLine={false} width={55}
              tickFormatter={v=>`${v.toFixed(3)}%`}/>
            <Tooltip contentStyle={{background:"#181c24",border:"1px solid #1e2433",borderRadius:8,fontSize:11}}/>
            <ReferenceLine y={0} stroke="#333" strokeDasharray="3 3"/>
            <Line type="monotone" dataKey="rate" stroke={EC[sel]||"#22c55e"} strokeWidth={1.5} dot={false}/>
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
